export default __webpack_public_path__ + "static/media/امیر رضایی.110ed916.jpeg";